import Cookies from 'js-cookie';

export default {
	/**
	 * Saves the given value to the given key in storage.
	 * @param {string} key The key to save into storage
	 * @param {mixed} value The value to save into storage
	 * @returns {void}
	 */
	put (key, value) {
		Cookies.set(key, value, { secure: false });
	},

	/**
	 * Returns true if the given key exists in storage.
	 * @param {string} key The key in storage.
	 * @returns {boolean}
	 */
	has (key) {
		return this.get(key) !== null;
	},

	/**
	 * Returns the value of the given key in storage.
	 * @param {string} key The key in storage.
	 * @returns {mixed|null} The value of the given key, or null if it does not exist.
	 */
	get (key) {
		return Cookies.get(key) || null;
	},

	/**
	 * Deletes the entry with the given key in storage.
	 * @param {string} key The key in storage.
	 * @returns {void}
	 */
	delete (key) {
		Cookies.remove(key);
	},

	/**
	 * Get the token from the storage container
	 *
	 * @returns {string?} Returns the jwt, or null if not set
	 */
	getToken () {
		return this.get('jwt');
	}
};
